import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState({
    subCategory: { index: 0 },
    category: { title: "Dashboard", index: 0 },
  });
  const [loader, setLoader] = useState(false);
  const [pageHistory, setPageHistory] = useState([null]);
  const [lastVisibleDoc, setLastVisibleDoc] = useState(null); // Last document of the current fetched page
  const [totalOrders, setTotalOrders] = useState(0); // Total count based on filters
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const [headerData, setHeaderData] = useState({
    leftText: "",
    rightActionText: "",
    leftAction: () => {},
    rightAction: () => {},
  });

  const [productsTabInfo, setProductsTabInfo] = useState({
    addProduct: false,
    trigger: false,
    selectedProduct: null,
    page: 1,
    totalPages: 1,
  });

  const [categoryTabInfo, setCategoryTabInfo] = useState({
    addCategory: false,
    trigger: false,
    selectedCategory: null,
    page: 1,
    totalPages: 1,
  });

  const [orderTabInfo, setOrderTabInfo] = useState({
    viewOrder: false,
    trigger: false,
    selectedOrder: null,
    page: 1,
    totalPages: 1,
  });

  const [customerTabInfo, setCustomerTabInfo] = useState({
    viewCustomer: false,
    trigger: false,
    selectedCustomer: null,
    page: 1,
    totalPages: 1,
    searchTerm: "",
    statusFilter: "All",
  });

  const [couponTabInfo, setCouponTabInfo] = useState({
    addCoupon: false,
    trigger: false,
    selectedCoupon: null,
    page: 1,
    totalPages: 1,
  });

  const handleResetTabInfo = () => {
    setOrderTabInfo({
      viewOrder: false,
      trigger: false,
      selectedOrder: null,
      page: 1,
      totalPages: 1,
    });
    setCategoryTabInfo({
      addCategory: false,
      trigger: false,
      selectedCategory: null,
      page: 1,
      totalPages: 1,
    });
    setProductsTabInfo({
      addProduct: false,
      trigger: false,
      selectedProduct: null,
      page: 1,
      totalPages: 1,
    });
    setCustomerTabInfo({
      viewCustomer: false,
      trigger: false,
      selectedCustomer: null,
      page: 1,
      totalPages: 1,
      searchTerm: "",
      statusFilter: "All",
    });
    setCouponTabInfo({
      addCoupon: false,
      trigger: false,
      selectedCoupon: null,
      page: 1,
      totalPages: 1,
    });
  };

  // Close mobile sidebar when navigating
  const handleTabChange = (newTab) => {
    setSelectedTab(newTab);
    setIsMobileSidebarOpen(false);
  };

  const value = {
    headerData,
    setHeaderData,
    loader,
    setLoader,
    productsTabInfo,
    setProductsTabInfo,
    selectedTab,
    setSelectedTab,
    handleTabChange,
    categoryTabInfo,
    setCategoryTabInfo,
    orderTabInfo,
    setOrderTabInfo,
    isCollapsed,
    setIsCollapsed,
    isMobileSidebarOpen,
    setIsMobileSidebarOpen,
    customerTabInfo,
    setCustomerTabInfo,
    couponTabInfo,
    setCouponTabInfo,
    handleResetTabInfo,
    pageHistory,
    setPageHistory,
    lastVisibleDoc,
    setLastVisibleDoc,
    totalOrders,
    setTotalOrders,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
